import { render } from "./Index_team_m.vue?vue&type=template&id=2a333670&scoped=true"
import script from "./Index_team_m.vue?vue&type=script&lang=js"
export * from "./Index_team_m.vue?vue&type=script&lang=js"

import "./Index_team_m.vue?vue&type=style&index=0&id=2a333670&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a333670"

export default script